// components/main/ObjektDetailForm.jsx

import React, {useState} from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { registerLocale } from "react-datepicker";
import de from "date-fns/locale/de";
import { useNavigate } from 'react-router';
registerLocale("de", de);

const ObjektDetailForm = ({
  formData,
  handleChange,
  onSave,
  onDelete,
  onCancel,
  editMode,
  setEditMode,
  kategorienData,
  ablageorteData,
  typenData,
  laenderData,
  materialienData,
  waehrungenData,
  zustaendeData,
  eigentuemerData,
  onImageChange,
  onImageDelete,
  selectedFiles,
  errorMessage
}) => {
  const [activeTab, setActiveTab] = useState("basis");
  const navigate = useNavigate();

  if (!formData || !formData.id) return <p>Lade Objekt...</p>;

  const TabButton = ({ id, label }) => (
    <li className="nav-item" role="presentation">
      <button
        className={`nav-link ${activeTab === id ? "active" : ""}`}
        onClick={() => setActiveTab(id)}
        type="button"
        role="tab"
      >
        {label}
      </button>
    </li>
  );

    const renderInput = (label, name, type = "text") => (
    <div className="col-md-4">
      <label className="form-label">{label}</label>
      <input
        type={type}
        name={name}
        value={formData[name] || ""}
        onChange={handleChange}
        disabled={!editMode}
        className="form-control"
      />
    </div>
  );

  const renderSelect = (label, name, options) => (
    <div className="col-md-4">
      <label className="form-label">{label}</label>
      <select
        name={name}
        value={formData[name] || ""}
        onChange={handleChange}
        disabled={!editMode}
        className="form-select"
      >
        <option value="">Bitte wählen</option>
        {options.map((opt) => (
          <option key={opt.id} value={opt.id}>
            {opt.name || `${opt.vorname} ${opt.name || ""}`}
          </option>
        ))}
      </select>
    </div>
  );

  const renderDatePicker = (label, name) => (
    <div className="col-md-4">
      <label className="form-label">{label}</label>
      <div className="input-group">
        <DatePicker
          selected={formData[name] ? new Date(formData[name]) : null}
          onChange={(date) => handleChange({ target: { name, value: date } })}
          dateFormat="dd.MM.yyyy"
          locale="de"
          placeholderText="dd.mm.yyyy"
          className="form-control w-100"
          wrapperClassName="w-100"
          disabled={!editMode}
        />
      </div>
    </div>
  );

  return (
    <div className="container mt-4">
      <div className="card shadow-sm">
        <div className="card-body">
          <h3 className="card-title mb-4">Münz-Details</h3>

          {editMode && (
            <div className="alert alert-warning d-flex align-items-center" role="alert">
              <i className="bi bi-pencil-square me-2"></i>
              Bearbeitungsmodus aktiv – Änderungen noch nicht gespeichert!
            </div>
          )}

          {errorMessage && (
            <div className="alert alert-danger" role="alert">
              ⚠️ {errorMessage}
            </div>
          )}

          {/* Tabs */}
          <ul className="nav nav-tabs mb-3" role="tablist">
            <TabButton id="basis" label="Basisdaten" />
            <TabButton id="erweitert" label="Erweiterte Daten" />
            <TabButton id="kommentare" label="Kommentare" />
            <TabButton id="bilder" label="Bilder" />
          </ul>

          <form>
            <div className="tab-content">
              {/* Basisdaten */}
              {activeTab === "basis" && (
                <div className="row g-2">
                  {renderInput("ID", "id", "text")}
                  {renderSelect("Kategorie", "kategorie", kategorienData)}
                  {renderSelect("Land", "land", laenderData)}
                  {renderSelect("Währung", "waehrung", waehrungenData)}
                  {renderInput("Nominalwert", "nominalwert", "number")}
                  {renderInput("Jahrgang", "jahrgang")}
                  {renderInput("Jahrgang Zusatz", "jahrgangZusatz")}

                  {renderSelect("Typ", "typ", typenData)}
                  {renderSelect("Material", "material", materialienData)}
                  <div className="col-12">
                    <label className="form-label">Beschreibung</label>
                    <textarea
                      className="form-control"
                      name="beschreibung"
                      value={formData.beschreibung || ""}
                      onChange={handleChange}
                      disabled={!editMode}
                      rows={3}
                    />
                  </div>
                </div>
              )}

              {/* Erweiterte Daten */}
              {activeTab === "erweitert" && (
                <div className="row g-2">
                  {renderInput("Sammlerwert", "sammlerwert", "number")}
                  {renderInput("Anzahl", "anzahl", "number")}
                  {renderSelect("Zustand", "zustand", zustaendeData)}
                  {renderSelect("Eigentümer", "eigentuemer", eigentuemerData)}
                  {renderSelect("Ablageort", "ablageort", ablageorteData)}
                  {/*{renderInput("Kaufdatum", "kaufdatum", "date")}*/}
                  {renderDatePicker("Kaufdatum", "kaufdatum")}
                  {renderInput("Kaufpreis", "kaufpreis", "number")}
                  {/*{renderInput("Verkaufsdatum", "verkaufsdatum", "date")}*/}
                  {renderDatePicker("Verkaufsdatum", "verkaufsdatum")}
                  {renderInput("Verkaufspreis", "verkaufspreis", "number")}
                  <div className="col-md-4">
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        className="form-check-input"
                        type="checkbox"
                        name="status_reinigung_offen"
                        checked={formData.status_reinigung_offen || false}
                        onChange={(e) =>
                          handleChange({
                            target: {
                              name: "status_reinigung_offen",
                              value: e.target.checked,
                            },
                          })
                        }
                        disabled={!editMode}
                      />
                      <label className="form-check-label">Reinigung offen</label>
                    </div>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        name="status_sammlung"
                        checked={formData.status_sammlung || false}
                        onChange={(e) =>
                          handleChange({
                            target: {
                              name: "status_sammlung",
                              value: e.target.checked,
                            },
                          })
                        }
                        disabled={!editMode}
                      />
                      <label className="form-check-label">In Sammlung</label>
                    </div>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        name="status_gesucht"
                        checked={formData.status_gesucht || false}
                        onChange={(e) =>
                          handleChange({
                            target: {
                              name: "status_gesucht",
                              value: e.target.checked,
                            },
                          })
                        }
                        disabled={!editMode}
                      />
                      <label className="form-check-label">Gesucht</label>
                    </div>
                  </div>
                  {formData.status_gesucht && (
                    <>
                      {renderInput("Wunschpreis", "wunschpreis", "number")}
                      {renderSelect("Wunschzustand", "wunschzustand", [])}
                    </>
                  )}
                </div>
              )}

              {/* comments */}
              {activeTab === "kommentare" && (
                <div className="mb-2">
                  <label className="form-label">Kommentare</label>
                  <textarea
                    className="form-control"
                    name="kommentare"
                    value={formData.kommentare || ""}
                    onChange={handleChange}
                    disabled={!editMode}
                    rows={5}
                  />
                </div>
              )}

              {/* images */}
              {activeTab === "bilder" && (
                <div className="row g-2">

                  {/* <div className="d-flex flex-column align-items-start">
                   */}
                   <div
                      className="d-flex flex-column align-items-start"
                      style={{ maxWidth: "350px" }}
                    >
                    <input
                      type="file"
                      accept="image/*"
                      onChange={(e) =>
                        onImageChange("bild01", e.target.files[0])
                      }
                      disabled={!editMode}
                      className="form-control"
                    />
                    <label className="form-label"></label>
                    {selectedFiles?.bild01 ? (
                      <img
                        src={URL.createObjectURL(selectedFiles.bild01)}
                        alt="Vorschau"
                        className="img-thumbnail mb-2"
                        style={{
                          width: "100%",
                          height: "auto",
                          objectFit: "contain"
                        }}
                      />
                    ) : formData.bild01 && (
                      <img
                        src={formData.bild01.startsWith("http") ? formData.bild01 : `${formData.bild01}`}
                        alt="Bild 01"
                        className="img-thumbnail mb-2"
                        style={{
                          width: "100%",
                          height: "auto",
                          objectFit: "contain"
                        }}
                      />
                    )}

                    {editMode && (selectedFiles?.bild01 || formData.bild01) && (
                      <button
                        type="button"
                        className="btn btn-danger mt-2"
                        onClick={() => onImageDelete("bild01")}
                        disabled={!editMode}
                      >
                        Delete
                      </button>
                    )}                    
                  </div>

                  <div
                    className="d-flex flex-column align-items-start"
                    style={{ maxWidth: "350px" }}
                  >
                    <input
                      type="file"
                      accept="image/*"
                      onChange={(e) =>
                        onImageChange("bild02", e.target.files[0])
                      }
                      disabled={!editMode}
                      className="form-control"
                    />
                    <label className="form-label"></label>
                    {selectedFiles?.bild02 ? (
                      <img
                        src={URL.createObjectURL(selectedFiles.bild02)}
                        alt="Vorschau"
                        className="img-thumbnail mb-2"
                        style={{
                          width: "100%",
                          height: "auto",
                          objectFit: "contain"
                        }}
                      />
                    ) : formData.bild02 && (
                      <img
                        src={formData.bild02.startsWith("http") ? formData.bild02 : `${formData.bild02}`}
                        alt="Bild 02"
                        className="img-thumbnail mb-2"
                        style={{
                          width: "100%",
                          height: "auto",
                          objectFit: "contain"
                        }}
                      />
                    )}

                    {editMode && (selectedFiles?.bild02 || formData.bild02) && (
                      <button
                        type="button"
                        className="btn btn-danger mt-2"
                        onClick={() => onImageDelete("bild02")}
                        disabled={!editMode}
                      >
                        Delete
                      </button>
                    )}
                  </div>
                </div>
              )}
            </div>

            {/* buttons */}
            <div className="mt-4 d-flex flex-wrap gap-2">
              {editMode ? (
              <>
                <button className="btn btn-warning" onClick={onCancel}>Abbrechen</button>
                <button className="btn btn-success" type="button" onClick={onSave}>Speichern</button>
              </>
              ) : (
              <>
                <button className="btn btn-secondary" onClick={() => navigate("/objekte")}>Zurück</button>
                <button className="btn btn-primary" type="button" onClick={() => setEditMode(true)}>Bearbeiten</button>
              </>
              )}
              <button className="btn btn-danger ms-auto" type="button" onClick={onDelete}>Löschen</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ObjektDetailForm;